<script lang="ts">
  import { renderMarkdown } from '../markdown';

  export let source: string | null | undefined = null;

  $: html = renderMarkdown(source);
</script>

{#if html}
  <div class="markdown">
    {@html html}
  </div>
{/if}

<style>
  .markdown {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    color: var(--color-text-secondary);
    font-size: var(--font-size-sm);
    line-height: var(--line-height-relaxed);
    overflow-wrap: anywhere;
  }

  .markdown :global(h2),
  .markdown :global(h3),
  .markdown :global(h4) {
    font-family: var(--font-display);
    color: var(--color-text-primary);
    margin: var(--space-2) 0 0;
  }

  .markdown :global(h2) {
    font-size: var(--font-size-lg);
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .markdown :global(h3) {
    font-size: var(--font-size-md);
  }

  .markdown :global(h4) {
    font-size: var(--font-size-base);
  }

  .markdown :global(p) {
    margin: 0;
  }

  .markdown :global(img) {
    max-width: 100%;
    height: auto;
    display: block;
    border: var(--border-subtle);
  }

  .markdown :global(ul),
  .markdown :global(ol) {
    margin: 0;
    padding-left: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }

  .markdown :global(blockquote) {
    margin: 0;
    padding: var(--space-2) var(--space-4);
    border-left: 2px solid rgb(var(--accent-rgb) / 0.6);
    color: var(--color-text-muted);
  }

  .markdown :global(hr) {
    width: 100%;
    border: none;
    border-top: var(--border-subtle);
    margin: var(--space-2) 0;
  }

  .markdown :global(code) {
    font-family: var(--font-mono);
    font-size: 0.85em;
    background: var(--color-surface-850);
    padding: 0.1em 0.35em;
  }

  .markdown :global(a) {
    color: var(--color-accent-text);
  }
</style>
